module.exports = __webpack_public_path__ + "media/reskin-images/icon--sales-5e909eac.svg";